var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.header ? 'th' : 'td',_vm._b({tag:"component",class:[
    _vm.data.class,
    _vm.data.staticClass
  ]},'component',_vm.data.attrs,false),[_vm._t("default"),(_vm.props.tooltip)?_c('v-tooltip',{attrs:{"bottom":"","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":""}},on),[_vm._v(" mdi-information ")])]}}],null,false,202161078)},[_c('span',[_vm._v(" "+_vm._s(_vm.props.tooltip)+" ")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }